import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { FileText, ShieldCheck, Calculator, PenTool, FileCheck, Mail, ArrowRight } from "lucide-react";

const STEPS = [
  { icon: FileText, t: "Share your details", d: "Choose a report and complete a short, private multi-step form: your full name, date of birth, and any optional preferences. Mandatory fields are clearly marked." },
  { icon: ShieldCheck, t: "Pay securely", d: "Review your order, accept the terms, and pay securely in INR. We confirm your payment before your report is prepared." },
  { icon: Calculator, t: "We calculate your numbers", d: "Your Life Path, Birth Day, Expression, Soul Urge, Personality and Personal Year numbers are calculated using your chosen methodology — consistently and with care." },
  { icon: PenTool, t: "Your report is written", d: "Your numbers and preferences guide a reading written individually for you — warm, readable, and specific to your life." },
  { icon: FileCheck, t: "PDF is built & polished", d: "Your reading is set into a beautifully formatted PDF and carefully checked before it's sent." },
  { icon: Mail, t: "Delivered to your inbox", d: "Your report arrives by email within approximately 6–7 hours of confirmed payment, with a secure private download link." },
];

export default function HowItWorks() {
  return (
    <>
      <Seo title="How It Works" path="/how-it-works" />
      <PageHeader eyebrow="How it works" title="A calm, automated journey"
        subtitle="From the moment you order to the report landing in your inbox, everything is handled for you — accurately and privately." />
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20">
        <ol className="space-y-6">
          {STEPS.map((s, i) => (
            <li key={s.t} className="flex gap-5 bg-white rounded-2xl border border-border p-6 sm:p-8 card-lift">
              <div className="shrink-0">
                <div className="w-12 h-12 rounded-full bg-navy text-ivory flex items-center justify-center font-mono-accent">{i + 1}</div>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <s.icon className="w-5 h-5 text-gold-hover" />
                  <h3 className="font-serif text-2xl text-navy">{s.t}</h3>
                </div>
                <p className="text-slate-600 leading-relaxed">{s.d}</p>
              </div>
            </li>
          ))}
        </ol>
        <div className="mt-12 text-center">
          <Link to="/pricing" className="btn-gold">Choose your report <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </>
  );
}
